var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationwarningDiamond = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3DC43",
  stroke: "#F3DC43",
  d: "M1.217 6.076 5.54 1.751a1 1 0 0 1 1.415 0l4.324 4.325a1 1 0 0 1 0 1.414l-4.324 4.325c-.39.39-1.024.39-1.415 0L1.217 7.49a1 1 0 0 1 0-1.414"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M6.5 7V4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.5"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M6.489 9.25a.25.25 0 0 0-.172.078.25.25 0 0 0-.065.177.254.254 0 0 0 .25.245h.009a.247.247 0 0 0 .237-.255.253.253 0 0 0-.246-.245"
})))));
export { SvgNotificationwarningDiamond as ReactComponent };
export default __webpack_public_path__ + "assets/images/notificationwarning-diamond.svg";